<div class="wrapper">
  <input class="t-s" type="text" [class.invalid]="invalid()" [value]="internal()" (input)="input($event)" />
  <span class="t-s-s" [class.error]="invalid()">{{ internal()?.length || 0 }}/{{ max() }}</span>
</div>
@if (aEvent(); as aEvent) {
  <mn-copy [aEvent]="aEvent + '_copy'" [value]="internal()" />
  <mn-button type="light" size="large" [aEvent]="aEvent + '_save'" [disabled]="invalid()" (clicked)="save($event)">
    <span class="t-h">{{ "btn.save" | mnTranslate }}</span>
  </mn-button>
}
